import Form from 'mlmi-library/components/form/v1/form'
import './characters'

$.fn.FormBabillard = function() {
  let self = this
  self.form = undefined
  self.feedback = undefined

  self.handle_success = function(response) {
    if ('feedback' in response) {
      $('input[name="form_id"]').val(response.form_id)
      let $container = self.closest('.container-md')
      $container.height($container.height())
      $('html, body').scrollTo($container.closest('.page-section').offset().top - $('.header').outerHeight(false), 350, 4, 'easeInOutQuart')
      self.fadeOut(350, function() {
        self.feedback = $('<html>').html(response.feedback).find('.row')
        self.feedback.find('a.action-edit-babillard').on('click', self.edit_submission)
        self.after(self.feedback.hide())
        self.feedback.fadeIn(350)
        $container.animate({
          height: $container.outerHeight(false) + 'px',
        }, 350, function() {
          $container.css('height', '')
        })
      })
    } else {
      location.href = response.redirect
    }
  }

  self.edit_submission = function(e) {
    e.preventDefault()
    self.form.getForm().enable_fields()
    self.feedback.fadeOut(150, function() {
      self.fadeIn(250)
    })
  }

  self.initialize_form = function() {
    self.form = new Form('.babillard-form', {
      auto_scroll: true,
      ajax_redirect: false,
      date_picker: {
        dateFormat: "dd/mm/yy",
      },
      onSuccess: self.handle_success
    })
  }

  self.initialize_fields = function() {
    self.find('textarea[maxlength]').each(function() {
      $(this).Characters()
    })
  }

  self.update_fields = function() {
    //
  }

  return function() {
    self.initialize_form()
    self.initialize_fields()
    return self
  }()
}
